import { Injectable } from '@angular/core';
import { FilterFacadeConfig } from '@pf/shared/util-platform';

@Injectable()
export abstract class LoadFilterFacadeConfig extends FilterFacadeConfig {}
